import { cn } from '@/lib/utils';
import type { PropsWithChildren } from 'react';

interface ContainerProps extends PropsWithChildren {
  className?: string;
}

/**
 * The page's content column — every band, the header and the footer align to it.
 *
 * Backgrounds and rules belong on the full-bleed element *around* this one, never on it: §1
 * builds structure out of edge-to-edge hairlines, and a band that stops at 1440px reads as a
 * card. The gutter sits inside the cap, so `--container-page` is the only number involved.
 */
const Container = ({ className, children }: ContainerProps) => (
  <div className={cn('mx-auto w-full max-w-page px-5 md:px-16', className)}>{children}</div>
);

export { Container };
